enum ExerciseSearchScope {
	Course,
	Personal,
	Organisation,
	Public,
}

export default ExerciseSearchScope;
